module.exports = __webpack_public_path__ + "static/media/plus.f164b50d.svg";